// console.log("speed-cards.js loaded");
document.addEventListener("DOMContentLoaded", (event) => {
  initSpeedSliderFunctions();
});
function initSpeedSliderFunctions() {
  console.log("speed-cards.js loaded");

  // FUNCTIONALITY FOR PLAN FINDER
  function setElementDisplayStyle(elementId, displayValue) {
    const element = document.getElementById(elementId);
    if (element) {
      element.style.display = displayValue;
    }
  }
  // display number of users
  const minusButton = document.querySelector("#planFinderModal .minus-button");
  const plusButton = document.querySelector("#planFinderModal .plus-button");
  const numberDisplay = document.querySelector("#planFinderModal .number");
  const chooseButton = document.querySelectorAll(
    "#planFinderModal .chooseFinderSpeed"
  );

  let onOrderPage = false;

  let count = 4;
  if (numberDisplay) {
    numberDisplay.textContent = count;
  }

  // Check if we're on the ordering page
  if (
    $("#order-info").length &&
    localStorage.getItem("lumos_location_id") &&
    localStorage.getItem("lumos_location_id") !== null
  ) {
    onOrderPage = true;
  }

  if (onOrderPage) {
    [].forEach.call(chooseButton, function (button) {
      button.innerText = "Order Online";
    });
  }

  minusButton.addEventListener("click", function () {
    if (count > 1) {
      count--;
      numberDisplay.textContent = count;
      updateRecommendedPlan();
    }
  });

  plusButton.addEventListener("click", function () {
    if (count < 10) {
      count++;
      numberDisplay.textContent = count;
      updateRecommendedPlan();
    }
  });

  [].forEach.call(chooseButton, function (button) {
    button.addEventListener("click", function () {
      var selectedProduct = document.querySelector(
        "#planFinderModal .product-container .internet-plan[style='display: block;']"
      );
      // console.log(
      //   selectedProduct,
      //   selectedProduct.getAttribute("data-legacy-name")
      // );
      localStorage.setItem(
        "lumos_default_product",
        selectedProduct.getAttribute("data-legacy-name")
      );
      pushToDataLayer(this.id);
      $("#planFinderModal").modal("hide");

      // Secondary check for ordering page
      if (
        $("#order-info").length &&
        localStorage.getItem("lumos_location_id") &&
        localStorage.getItem("lumos_location_id") !== null
      ) {
        onOrderPage = true;
      }

      // We're on the order page with a validated address
      if (onOrderPage) {
        setDefaultProduct();
        // We're somewehre else.
      } else {
        $("#addressCheckerModal").modal("show");
      }
    });
  });

  var modalElement = document.getElementById("planFinderModal");

  modalElement.addEventListener("hidden.bs.modal", function () {
    pushToDataLayer("help_me_choose_exit");
  });

  var helpMeChooseEntrance = document.getElementById("help_me_choose_entrance");
  helpMeChooseEntrance.addEventListener("click", function () {
    pushToDataLayer("help_me_choose_entrance");
  });

  // define consts
  const basicActivities = document.querySelectorAll(
    "#planFinderModal .basic-activities-container input"
  );
  const advancedActivities = document.querySelectorAll(
    "#planFinderModal .advanced-activities"
  );
  const advanced5GigActivities = document.querySelectorAll(
    "#planFinderModal .advanced-5-gig-activities"
  );
  const advanced8GigActivities = document.querySelectorAll(
    "#planFinderModal .advanced-8-gig-activities"
  );
  const allCards = document.querySelectorAll("#planFinderModal .internet-plan");
  const mbps200 = document.getElementById("speed-200");
  const mbps500 = document.getElementById("speed-500");
  const gig1 = document.getElementById("speed-1");
  const gig2 = document.getElementById("speed-2");
  const gig5 = document.getElementById("speed-5");
  const gig8 = document.getElementById("speed-8");

  function updateRecommendedPlan() {
    envConsoleLog("updateRecommendedPlan");
    // if(onOrderPage) {
    //   return;
    // }

    const selectedBasicActivities = basicActivities
      ? Array.from(basicActivities).filter((input) => input.checked)
      : [];
    const selectedAdvancedActivities = advancedActivities
      ? Array.from(advancedActivities).filter((input) => input.checked)
      : [];
    const selectedAdvanced5GigActivities = advanced5GigActivities
      ? Array.from(advanced5GigActivities).filter((input) => input.checked)
      : [];
    const selectedAdvanced8GigActivities = advanced8GigActivities
      ? Array.from(advanced8GigActivities).filter((input) => input.checked)
      : [];

    const numberValue = parseInt(numberDisplay.textContent);

    // hide and display plans
    setElementDisplayStyle("speed-200", "none");
    setElementDisplayStyle("speed-500", "none");
    setElementDisplayStyle("speed-1", "none");
    setElementDisplayStyle("speed-2", "none");
    setElementDisplayStyle("speed-5", "none");
    setElementDisplayStyle("speed-8", "none");

    if (numberValue === 1) {
      mbps500.style.display = "block";
    } else if (numberValue === 2) {
      if (selectedAdvancedActivities.length === 0) {
        mbps500.style.display = "block";
      } else {
        mbps500.style.display = "block";
      }
    } else if (numberValue === 3 || numberValue === 4) {
      if (selectedAdvancedActivities.length > 0) {
        gig1.style.display = "block";
      } else {
        gig1.style.display = "block";
      }
    } else if (numberValue >= 5 && selectedAdvancedActivities.length > 0) {
      gig2.style.display = "block";
    } else if (numberValue >= 5) {
      gig1.style.display = "block";
    }

    // override and show 5 if certain options selected
    if (selectedAdvanced5GigActivities.length > 0) {
      allCards.forEach((card) => {
        card.style.display = "none";
      });
      if (gig5) {
        gig5.style.display = "block";
      } else if (gig2) {
        gig2.style.display = "block";
      } else if (gig1) {
        gig1.style.display = "block";
      }
    }

    if (selectedAdvanced8GigActivities.length > 0) {
      allCards.forEach((card) => {
        card.style.display = "none";
      });
      if (gig8) {
        gig8.style.display = "block";
      } else if (gig5) {
        gig5.style.display = "block";
      } else if (gig2) {
        gig2.style.display = "block";
      } else if (gig1) {
        gig1.style.display = "block";
      }
    }
  }

  // event listeners
  document
    .querySelector("#planFinderModal .basic-activities-container")
    .addEventListener("change", updateRecommendedPlan);
  document
    .querySelector("#planFinderModal .advanced-activities-container")
    .addEventListener("change", updateRecommendedPlan);

  // call the function when the page loads
  updateRecommendedPlan();

  show5GigSpeedcard();

  shopNowListener();

  // set heights of additional section the same

  // when doucment full loaded
  // if (localStorage.getItem("lumos_address_market") && localStorage.getItem("lumos_address_market") !== "default") {
  // envConsoleLog("fixing speed card section height");
  $(".speed-cards-carousel:not(.fieldset-container)").each(function () {
    var maxHeight = 0;
    var contentMaxHeight = 0;

    // Find the tallest .additional-section in the current carousel
    $(this)
      .find(".additional-section")
      .each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > maxHeight) {
          maxHeight = thisHeight;
        }
      });
    // find the tallest .content-section
    $(this)
      .find(".content-section")
      .each(function () {
        var thisContentHeight = $(this).height();
        if (thisContentHeight > contentMaxHeight) {
          contentMaxHeight = thisContentHeight;
        }
      });
    // // Set all .additional-section heights within the current carousel to the tallest found height
    $(this).find(".additional-section").height(maxHeight);
    $(this).find(".content-section").height(contentMaxHeight);
  });
  // }
}

function show5GigSpeedcard() {
  // console.log("show5GigSpeedcar");
  // hide 5Gig price for non-tidewater customers
  if (localStorage.getItem("lumos_address_market")) {
    var $fiveGigCard = $('div.card[data-product-id="5000"]');
    if (localStorage.getItem("lumos_address_market") !== "tidewater") {
      // console.log("not tidewater");
      $fiveGigCard.each(function () {
        $(this).removeClass("border-most-popular");
        $(this).find(".most-popular").addClass("hide");
        $(this).find(".price").addClass("hide");
        $(this).find(".no-price").removeClass("hide");
      });
    } else {
      // console.log("is tidewater");
      $fiveGigCard.each(function () {
        // $(this).addClass("border-most-popular");
        $(this).find(".most-popular").removeClass("hide");
        $(this).find(".price").removeClass("hide");
        $(this).find(".no-price").addClass("hide");
      });
    }
  }
}

function pushToDataLayer(eventType, additionalData = {}) {
  window.dataLayer = window.dataLayer || [];
  const defaultData = {
    data: "modal:help_me_choose",
  };
  const eventData = {
    event: eventType,
    ...defaultData,
    ...additionalData, // This will overwrite default data if the keys match
  };
  // console.log("pushToDataLayer", eventData);
  window.dataLayer.push(eventData);
}

// function to get .shop-now-button click event and trigger the .shop-now-checkbox inside of it
function shopNowListener() {
  const shopNowButtons = document.querySelectorAll(
    ".speed-cards-carousel:not(.fieldset-container) .shop-now-button, .plan-finder-tool .shop-now-button"
  );
  shopNowButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const checkbox = button.querySelector(".shop-now-checkbox");
      // get the .card that is a parent of the button andd get its data-slide-index
      var card = button.closest(".card");
      const slideIndex = card.getAttribute("data-slide-index");
      // localStorage.setItem("selected_feature_slide", slideIndex);

      // if card is not set, get closest .internet-plan instead
      if (!card) {
        card = button.closest(".internet-plan");
      }

      localStorage.setItem(
        "lumos_default_product",
        card.getAttribute("data-legacy-name")
      );
      checkbox.click();
    });
  });
}

setSpeedSliderDropdowns();
function setSpeedSliderDropdowns() {
  // custom dropdown for section slides
  $(".wf-speed-cards .custom-dropdown").on("click", function () {
    $(this).find(".dropdown-section").toggle();
    $(this).find(".dropdown-icon").toggleClass("rotate");
    // Close all other dropdowns
    $(".wf-speed-cards .custom-dropdown")
      .not(this)
      .find(".dropdown-section")
      .hide();
  });

  // prevent link clicks from closing dropdown
  $(".wf-speed-cards .custom-dropdown").on(
    "click",
    "a, button",
    function (event) {
      event.stopPropagation();
    }
  );
}

$(document).ready(function () {
  refreshSlide();
});
// listener on custom event for when the address is hcanged
window.addEventListener("lumosAddressChange", refreshSlide);

function refreshSlide() {
  refreshUPIData();
  setSpeedSliderDropdowns();
}
